import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import PageTopTitle from "../../components/shared/PageTopTitle";
import TopMenus from "../../components/shared/TopMenus";
import InspectionStationLocation from "../../components/inspectionStation/InspectionStationLocation";
import InspectionRoadRoute from "../../components/inspectionStation/InspectionRoadRoute";

const Container = styled.div`
  width: 100%;
  height: 100%;
  .content{
    margin: 30px;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
`

const menuData = [
  {
    id:0,
    text:"Karayolları İstasyonları"
  },
  {
    id:1,
    text:"Konumlar"
  }
]

const KarayollariIstasyonlari = () => {
  const dispatch = useDispatch();
  const [activeMenuId, setActiveMenuId] = useState(0)

  return (
    <Container>
      <div className="wrapper">
        <PageTopTitle title={"Karayolları İstasyonları"} position="sticky" />

        <div className="content">
          <TopMenus menuList={menuData} activeMenuId={activeMenuId} setActiveMenuId={setActiveMenuId} />

          {
            activeMenuId === 0 && (
              <InspectionStationLocation />
            )
          }
          
          {
            activeMenuId === 1 && (
              <InspectionRoadRoute />
            )
          }

        </div>
      </div>
    </Container>
  );
};

export default KarayollariIstasyonlari;
